import { FieldViewType } from "./viewType";
/**
 * Dictionary of the available fields and components
 */
export default new (/** @class */ (function () {
    /**
     * Create a new instance of the dictionary
     */
    function FieldsDictionary() {
        var _this = this;
        this.dictionary = new Map();
        var types = [
            FieldViewType.DETAIL,
            FieldViewType.EDIT,
            FieldViewType.LIST,
        ];
        types.forEach(function (type) {
            _this.dictionary.set(type, new Map());
        });
    }
    /**
     * Register a field into the dictionary
     * @param {FieldViewType} type
     * @param {ComponentClass} component
     */
    FieldsDictionary.prototype.registerField = function (type, field, component) {
        var _a;
        if (!this.dictionary.has(type)) {
            return false;
        }
        (_a = this.dictionary.get(type)) === null || _a === void 0 ? void 0 : _a.set(field, component);
        return true;
    };
    /**
     * Get the fields from the dictionary
     *
     * @param {FieldViewType} type
     */
    FieldsDictionary.prototype.getFields = function (type) {
        return this.dictionary.get(type);
    };
    /**
     * Check if dictionary has a field of the specified type
     *
     * @param type
     * @param field
     * @returns true if a field does exist and false otherwise
     */
    FieldsDictionary.prototype.hasField = function (type, field) {
        var _a;
        return (this.dictionary.has(type) &&
            ((_a = this.dictionary.get(type)) === null || _a === void 0 ? void 0 : _a.has(field)));
    };
    /**
     * Get the declared component of a field
     *
     * @param type
     * @param field
     *
     * @returns The field component
     */
    FieldsDictionary.prototype.getField = function (type, field) {
        var _a;
        if (!this.hasField(type, field)) {
            return undefined;
        }
        return (_a = this.dictionary.get(type)) === null || _a === void 0 ? void 0 : _a.get(field);
    };
    return FieldsDictionary;
}()))();
